import { useState } from "react";
import { Link } from "react-router-dom";
import { acceptTerms } from "../api";
import { useMe, useSession } from "../state";

export function TermsGate() {
  const { signOut, token } = useSession();
  const { me, refresh } = useMe();
  const [adult, setAdult] = useState(false);
  const [terms, setTerms] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (!me || me.accepted_terms) return null;

  const submit = async () => {
    if (!adult || !terms) return;
    setBusy(true); setErr(null);
    try {
      const t = (await token())!;
      await acceptTerms(t);
      await refresh();
    } catch (e: any) {
      setErr(e.message || "couldn't save");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-ink/40 backdrop-blur-sm grid place-items-center px-4">
      <div className="bg-cream rounded-3xl shadow-soft max-w-md w-full p-7 animate-rise">
        <h2 className="font-display font-black text-2xl mb-1">welcome 👋</h2>
        <p className="text-ink-soft mb-5 text-sm">before your first render, please confirm:</p>

        <label className="flex gap-3 items-start mb-3 cursor-pointer">
          <input
            type="checkbox"
            checked={adult}
            onChange={(e) => setAdult(e.target.checked)}
            className="mt-1 size-4 accent-coral"
          />
          <span className="text-sm leading-snug">
            I am <b>at least 18 years old</b>.
          </span>
        </label>

        <label className="flex gap-3 items-start mb-5 cursor-pointer">
          <input
            type="checkbox"
            checked={terms}
            onChange={(e) => setTerms(e.target.checked)}
            className="mt-1 size-4 accent-coral"
          />
          <span className="text-sm leading-snug">
            I have read and accept the{" "}
            <Link to="/terms" target="_blank" className="text-coral-dark underline">terms</Link> and{" "}
            <Link to="/privacy" target="_blank" className="text-coral-dark underline">privacy policy</Link>,
            including the rules against uploading minors or non-consensual content.
          </span>
        </label>

        <button
          className="btn-primary w-full"
          disabled={busy || !adult || !terms}
          onClick={submit}
        >
          {busy ? "saving…" : "continue"}
        </button>

        {err && <p className="text-sm text-coral-dark mt-3">{err}</p>}

        <button
          onClick={signOut}
          className="block mt-3 mx-auto text-xs text-ink-mute hover:text-ink-soft"
        >
          sign out instead
        </button>
      </div>
    </div>
  );
}
